import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--notification-badge"
export default class extends Controller {
  static targets = [ "badge", "text" ]
  static values = { url: String, refreshInterval: Number }

  connect() {
    this.updateCount()
    
    // ページ遷移時(戻る等)のTurbo復元時にも即座に更新する
    document.addEventListener("turbo:render", this.updateCount.bind(this))

    if (this.hasRefreshIntervalValue) {
      this.timer = setInterval(() => {
        this.updateCount()
      }, this.refreshIntervalValue)
    }
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    document.removeEventListener("turbo:render", this.updateCount.bind(this))
  }

  async updateCount() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        }
      })
      if (response.ok) {
        const data = await response.json()
        this.renderBadge(data.count)
      }
    } catch (error) {
      console.error("Failed to fetch unread notification count:", error)
    }
  }

  renderBadge(count) {
    if (count > 0) {
      // バッジのコンテナターゲットが存在する場合（ダッシュボード等のアイコン用）
      if (this.hasBadgeTarget) {
        this.badgeTarget.classList.remove("hidden")
      }
      
      // テキストターゲットが存在する場合（サイドバーの数値バッジ等）
      if (this.hasTextTarget) {
        this.textTarget.textContent = count
        if (this.textTarget.tagName === "SPAN" && this.textTarget.classList.contains("hidden")) {
           this.textTarget.classList.remove("hidden")
        }
      }
    } else {
      if (this.hasBadgeTarget) {
        this.badgeTarget.classList.add("hidden")
      }
      if (this.hasTextTarget) {
        if (this.textTarget.tagName === "SPAN") {
          this.textTarget.classList.add("hidden")
        }
        this.textTarget.textContent = ""
      }
    }
  }
}
